export default "/images/vendor/flag-icon-css/flags/4x3/hn.svg?f53ee3d65d19c9dd755eb992a52ae727";